import {
    ACTIVE,
    BLOCKED,
    COLOR_ACTIVE,
    COLOR_BLOCKED,
    COLOR_EXPIRED,
    COLOR_SUSPENDED,
    EXPIRED,
    SUSPENDED
} from "./FuelsConstants";
import {useTranslation} from "react-i18next";


export const useRegistryFuelCardStatuses = () => {

    const {t} = useTranslation(['finance'], {keyPrefix: 'registryFuelCard.filters.statuses'});

    const getRegistryFuelCardStatusColor = (status: string) => {
        switch (status) {
            case ACTIVE: return COLOR_ACTIVE;
            case EXPIRED: return COLOR_EXPIRED;
            case BLOCKED: return COLOR_BLOCKED;
            case SUSPENDED: return COLOR_SUSPENDED;
        }
    };
    const getRegistryFuelCardStatuses = (status: string) => {
        switch (status) {

            case ACTIVE:    return t('ACTIVE');
            case EXPIRED:   return t('EXPIRED');
            case BLOCKED:   return t('BLOCKED');
            case SUSPENDED: return t('SUSPENDED');

            default : return '-'
        }
    };

     const statuses = [
        {
            value: ACTIVE,
            label: getRegistryFuelCardStatuses(ACTIVE)
        },
        {
            value: EXPIRED,
            label: getRegistryFuelCardStatuses( EXPIRED)
        },
        {
            value: BLOCKED,
            label: getRegistryFuelCardStatuses( BLOCKED)
        },
        {
            value: SUSPENDED,
            label: getRegistryFuelCardStatuses(SUSPENDED)
        }
    ];

    return {
        statuses, getRegistryFuelCardStatuses, getRegistryFuelCardStatusColor
    }
}